<template>
  <template v-if="isLoaded">
    <div class="menu-view">
      <div class="farm-window text-window" id="help-window">
        <div>
          <h2>Patch Notes</h2>
        </div>
        <TextButton class="farm-button" @click="$emit('close')">
          <h3>X</h3>
        </TextButton>
        <div class="farm-list help-list">
          <div v-for="patch in saveSystem.patchNotes"  class="farm-window patch-window">
            <h2 v-if="patch.name.length > 0" style="margin-bottom: 1em;">{{patch.id}} - {{patch.name}}</h2>
            <h2 v-else style="margin-bottom: 1em;">{{patch.id}}</h2>
            <h4 style="font-weight: normal; text-align: right; margin-bottom: 22px;">{{patch.date}}</h4>
            <div class="md-patchnotes" style="grid-column: span 2;" v-html="patch.text"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"

@Options({
  components: {
    TextButton
  },
  props: {
    saveSystem: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class PatchNotesScreen extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
}
</script>

<style lang="scss">
.md-patchnotes {
  h1 {
    font-size: large;
  }

  ul {
    list-style-type: none;
    padding-left: 15px;
    margin: 10px 0;

    li {
      border-left: 3px solid #ddd;
      padding: 0 10px;
      margin-bottom: 7px;
      background: rgba($component-background-color, 0.5);

      ul {
        padding-left: 1ch;
        margin: 5px 0 0 0;

        li {
          list-style-type: disc;
          list-style-position: inside;
          color: #ccc;
          border-left: 0 solid;
          background: rgba($component-background-color, 0);
          font-style: italic;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">

.menu-view {
  //max-width: $full-page-width;
  height: 100vh;

  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    "t"
    "t";
  grid-gap: 20px;

  @media screen and (max-width: $mobile-width){
    grid-template-areas:
      "t"
      "t";
    margin: 0;
  }
}

.text-window {
  grid-area: t;

  box-sizing: border-box;
  flex-direction: column;
  min-height: 200px;
  max-width: 700px;
  max-height: 100%;
  margin: 20px auto;
  padding: 20px;

  display: grid;
  grid-template-rows: 30px auto;
  grid-template-columns: auto 50px;
  grid-template-areas:
    "t x"
    "c c";
  grid-gap: 10px;

  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media screen and (max-width: $mobile-width){
    padding: 10px;
    margin: 0 auto;
  }
}

.patch-window {
  display: grid !important;
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr 1fr;
}

.start-menu-text {
  background: $component-background-color;
  margin: 10px auto 50px auto;
  width: 100%;
  box-sizing: border-box;
}

.start-menu-buttons {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;

  .text-button {
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    margin: 5px 0;
  }
}

.blushing-defeat-button-row {
  grid-template-columns: 1fr !important;
  height: 50px;
  margin-top: auto;
}

.stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(40px, 1fr);
}

.text-button {
  border: $component-border-style;

  display: table;
  div {
    display: table-cell;
    vertical-align: middle;
  }

  & > h3 {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

.help-list {
  grid-area: c;

  overflow-y: auto;

  .farm-window {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
}

</style>
